import React, { useContext } from 'react';
import { Button, Icon } from '@amzn/awsui-components-core';
import { UserCommentState } from '@amzn/awscat-pattern-library-service-model';

import { ContentViewerContext } from '../workflow-viewer/ContentViewerContext';

interface Props {
  handleShowAllComments: () => void;
}

const ShowAllCommentsButton = (props: Props) => {
  const { handleShowAllComments } = props;

  const contentViewerContext = useContext(ContentViewerContext);
  const { inlineComments } = contentViewerContext;

  const handleClick = () => {
    if (handleShowAllComments) {
      handleShowAllComments();
    }
    contentViewerContext?.enableCommentMode?.(true);
  };

  const getShowCommentsText = () => {
    let text = '';
    const openComments = inlineComments?.filter(
      (comment) => comment.state === UserCommentState.PENDING,
    );
    if (!openComments?.length) {
      text = 'Enable commenting mode';
    } else if (openComments?.length) {
      text = `Review ${openComments.length} comment${openComments.length > 1 ? 's' : ''}`;
    }
    return text;
  };

  return (
    <Button fullWidth iconName="contact" onClick={handleClick}>
      {getShowCommentsText()}
    </Button>
  );
};

export default ShowAllCommentsButton;
